/**
 * Утренний план (17.10).
 *
 * Не список задач, а одна карточка: день целиком за один взгляд, особые
 * заметки отдельно, и одна кнопка «Понятно, начинаем». После неё родитель
 * видит, что план прочитан — это снимает утренние «ты видела сообщение?».
 */

import { useAckPlan, type DayPlan } from '@/shared/api/schedule'
import { haptic } from '@/shared/telegram'
import { Button } from '@/shared/ui/Button'
import { Icon } from '@/shared/ui/Icon'
import { taskIcon } from '@/shared/ui/icon-map'
import { Card, Chip } from '@/shared/ui/primitives'
import { toast } from '@/shared/ui/toast'

export function MorningPlan({ plan, familyId }: { plan: DayPlan; familyId: number }) {
  const ack = useAckPlan(familyId, {
    onSuccess: () => {
      haptic('success')
      toast.success('Родители видят, что вы посмотрели план')
    },
    onError: (error) => toast.error(error.message),
  })

  if (plan.tasks.length === 0 && plan.special_notes.length === 0) return null

  return (
    <Card className="enter">
      <div className="flex items-start justify-between gap-2">
        <h2 className="font-display text-lead font-bold">
          Сегодня{plan.child_name ? ` с ${plan.child_name}` : ''}
        </h2>
        {plan.acknowledged && <Chip tone="success">просмотрено</Chip>}
      </div>

      {plan.tasks.length > 0 && (
        <ul className="mt-3 space-y-1.5">
          {plan.tasks.map((task) => (
            <li key={task.id} className="flex items-center gap-2 text-body">
              <span className="tabular text-text-muted w-11 shrink-0">
                {task.time_start.slice(0, 5)}
              </span>
              {/* Значок по виду задачи: task.emoji остаётся в данных ради бота. */}
              <Icon name={taskIcon(task.kind)} size={20} />
              <span className="min-w-0 flex-1 truncate">
                {task.title}
                {task.place && <span className="text-text-muted"> · {task.place}</span>}
              </span>
            </li>
          ))}
        </ul>
      )}

      {plan.special_notes.length > 0 && (
        <div className="bg-warm-soft mt-3 rounded-[var(--radius-tile)] p-3">
          <p className="text-warm-ink flex items-center gap-1.5 text-caption font-semibold">
            <Icon name="incident" size={18} />
            Особое внимание
          </p>
          <ul className="mt-1 space-y-1">
            {plan.special_notes.map((note) => (
              <li key={note} className="text-note leading-snug">
                {note}
              </li>
            ))}
          </ul>
        </div>
      )}

      {!plan.acknowledged && (
        <Button className="mt-4" block loading={ack.isPending} onClick={() => ack.mutate()}>
          Понятно, начинаем
        </Button>
      )}
    </Card>
  )
}
